import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';
import { Adresse } from "./adresse";

@inheritSerialization(Adresse)
export class BanAdresse extends Adresse {

  @deserialize
  label = '';

}
